var _style, _g, _path, _g2, _g3, _g4, _path2, _path3, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg07UploadAadhar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 415.2 252.3",
    style: {
      enableBackground: "new 0 0 415.2 252.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#042b62;}\r\n\t.st1{opacity:0.1;enable-background:new    ;}\r\n\t.st2{opacity:0.2;enable-background:new    ;}\r\n\t.st3{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st4{fill:#1A2E35;}\r\n\t.st5{fill:#F5F5F5;}\r\n\t.st6{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st7{fill:#EBB376;}\r\n\t.st8{fill:#263238;}\r\n\t.st9{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st10{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st11{fill:#D58745;}\r\n\t.st12{opacity:0.3;}\r\n\t.st13{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--credit-card--inject-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.8,
    y: 166.6,
    className: "st0",
    width: 0.8,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.8,
    y: 166.6,
    className: "st1",
    width: 0.8,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.8,
    y: 97.4,
    className: "st0",
    width: 0.8,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.8,
    y: 115.6,
    className: "st0",
    width: 0.8,
    height: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.8,
    y: 97.4,
    className: "st1",
    width: 0.8,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.8,
    y: 115.6,
    className: "st1",
    width: 0.8,
    height: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358,57v117.3c0,6.4-5.3,11.6-11.7,11.6H146.2c-6.4,0-11.6-5.2-11.6-11.6V57.1c0-6.5,5.2-11.7,11.6-11.7h200.1 C352.7,45.4,357.9,50.6,358,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M358,57v117.3c0,6.4-5.3,11.6-11.7,11.6H146.2c-6.4,0-11.6-5.2-11.6-11.6V57.1c0-6.5,5.2-11.7,11.6-11.7h200.1 C352.7,45.4,357.9,50.6,358,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.9,92.2v38c0,2.8-2.2,5-5,5h-34.5c-2.8,0-5-2.2-5-5v-38c0-2.8,2.2-5,5-5h34.5 C331.6,87.1,333.8,89.4,333.9,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M333.9,92.2v38c0,2.8-2.2,5-5,5h-34.5c-2.8,0-5-2.2-5-5v-38c0-2.8,2.2-5,5-5h34.5 C331.6,87.1,333.8,89.4,333.9,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.2,148.2v4.9c0,2.9-2.3,5.2-5.2,5.2H172.5c-2.9,0-5.2-2.3-5.2-5.2v-4.9c0-2.9,2.3-5.2,5.2-5.2H331 C333.9,143,336.2,145.3,336.2,148.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M336.2,148.2v4.9c0,2.9-2.3,5.2-5.2,5.2H172.5c-2.9,0-5.2-2.3-5.2-5.2v-4.9c0-2.9,2.3-5.2,5.2-5.2H331 C333.9,143,336.2,145.3,336.2,148.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.3,107.2L184.3,107.2c0-0.8,0.6-1.4,1.4-1.4h94.7c0.8,0,1.4,0.6,1.4,1.4l0,0c0,0.8-0.6,1.4-1.4,1.4h-94.7 C184.9,108.6,184.3,108,184.3,107.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.3,116.1L184.3,116.1c0-0.8,0.6-1.4,1.4-1.4h94.7c0.8,0,1.4,0.6,1.4,1.4l0,0c0,0.8-0.6,1.4-1.4,1.4h-94.7 C184.9,117.5,184.3,116.9,184.3,116.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.3,125.4L184.3,125.4c0-0.8,0.6-1.4,1.4-1.4h94.7c0.8,0,1.4,0.6,1.4,1.4l0,0c0,0.8-0.6,1.4-1.4,1.4h-94.7 C184.9,126.8,184.3,126.2,184.3,125.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M83.1,98.1c0,0-7.4,19.4,0,36.3c7.4,16.9,28.3,6.7,30.3,2.7c2.1-4-2.8-12.3-2.8-19.8c0-7.6,1.8-11.7,0.4-17.9 C109.9,93.2,83.1,98.1,83.1,98.1z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    className: "st5",
    cx: 215.8,
    cy: 222.2,
    rx: 193.9,
    ry: 11.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.9,31.2h34.9c2.8,0,5.1,2.3,5.1,5.1v33.9c0,2.8-2.3,5.1-5.1,5.1H82.6l1.5,10.2l-7-10.2H61.9 c-2.8,0-5.1-2.3-5.1-5c0,0,0,0,0,0V36.3C56.8,33.5,59.1,31.2,61.9,31.2C61.9,31.2,61.9,31.2,61.9,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M61.9,31.2h34.9c2.8,0,5.1,2.3,5.1,5.1v33.9c0,2.8-2.3,5.1-5.1,5.1H82.6l1.5,10.2l-7-10.2H61.9 c-2.8,0-5.1-2.3-5.1-5c0,0,0,0,0,0V36.3C56.8,33.5,59.1,31.2,61.9,31.2C61.9,31.2,61.9,31.2,61.9,31.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M107.1,139.1c0,0,2.5,22.1,3.3,24.8s12.1,16.7,12.1,16.7l-3.2,1.7c0,0-12-12.3-13.9-16s-4.8-22.8-4.8-22.8 L107.1,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M104.9,129.2c4.1,2.2,5.5,32.9,5.5,32.9l2.1,3.2l-6.4,4.6c-1.5-2.5-2.9-5.2-4-7.9c-1.3-3.4-4.3-20.3-4.3-20.3 L104.9,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M104.9,129.2c4.1,2.2,5.5,32.9,5.5,32.9l2.1,3.2l-6.4,4.6c-1.5-2.5-2.9-5.2-4-7.9c-1.3-3.4-4.3-20.3-4.3-20.3 L104.9,129.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "105.2,169.9 112.5,164.1 114.1,167.4 107.3,172.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "105.2,169.9 112.5,164.1 114.1,167.4 107.3,172.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.5,168.8l7.5,11.8c14.8-3.5,62.4-10.7,68.2,5.6c7.3,20.3-45.2,36.4-74.2,37.4s-52.3-15.5-33.9-57.8 L88.5,168.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.5,168.8l7.5,11.8c14.8-3.5,62.4-10.7,68.2,5.6c7.3,20.3-45.2,36.4-74.2,37.4s-52.3-15.5-33.9-57.8 L88.5,168.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.8,215c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.2c0.1-0.3,1.1-3.1,2-3.4c0.2-0.1,0.4,0,0.6,0.2 c0.3,0.2,0.4,0.6,0.4,0.9c-0.2,0.5-0.5,1-0.9,1.3C157,214.2,156.4,214.6,155.8,215z M156,214.4c0.9-0.4,1.6-1.1,2.1-2 c0-0.2,0-0.5-0.2-0.6c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.1C156.8,212.6,156.4,213.5,156,214.4L156,214.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.8,215c-0.1,0-0.1,0-0.2,0c-0.1-0.1-1.4-1.8-1.2-2.9c0.1-0.3,0.2-0.5,0.5-0.7c0.2-0.2,0.5-0.2,0.8-0.1 c0.7,0.5,0.6,2.8,0.3,3.6v0.1L155.8,215z M155,211.6c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.9,0.3,1.7,0.9,2.3c0.2-1,0.1-2.5-0.3-2.8 C155.4,211.5,155.3,211.4,155,211.6L155,211.6L155,211.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.8,219.7c0-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.1,0.1c0.1,0.3,0.6,3.2-0.1,4c-0.2,0.2-0.4,0.2-0.6,0.1 c-0.4-0.1-0.6-0.3-0.8-0.6c-0.1-0.5-0.1-1.1,0.2-1.6C104.1,220.9,104.4,220.3,104.8,219.7z M104.8,220.3c-0.6,0.8-0.9,1.8-0.9,2.7 c0.1,0.2,0.3,0.4,0.5,0.4c0.1,0,0.2,0,0.2,0c0.1-0.1,0.1-0.1,0.1-0.2C105,222.2,105,221.2,104.8,220.3L104.8,220.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "123.8,205 111.9,209.2 106.1,211.3 107.6,217.6 113.1,216.4 126.7,213.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M109.2,217.9l-1-7.4c-0.1-0.4-0.4-0.7-0.8-0.6c0,0,0,0,0,0l-3.6,0.6c0,0-5,0.5-6,1.7 c-2.9,3.7-1.1,20.1,0.8,20.7c0.7,0.2,1.4-0.8,1.8-1.4c1-2.1,2.7-7.6,3.5-9.4c1-2,3.6-3,4.8-3.4C109,218.6,109.2,218.2,109.2,217.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.8,219.6c0.1,0,0.1,0,0.2,0c0.1,0,2.1,0.9,2.5,2c0.1,0.3,0.1,0.6-0.1,0.8c-0.1,0.3-0.4,0.5-0.6,0.4 c-0.9-0.1-1.9-2.1-2-3v-0.1C104.8,219.7,104.8,219.7,104.8,219.6z M107.1,222.2c0-0.2,0-0.3,0-0.5c-0.2-0.7-1.3-1.3-1.9-1.6 c0.3,1,1.1,2.3,1.6,2.4C106.8,222.4,107,222.4,107.1,222.2L107.1,222.2L107.1,222.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "123.8,205 111.9,209.2 113.1,216.4 126.7,213.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "115.3,217.5 118.7,217.7 116.4,205.9 112.5,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "115.3,217.5 118.7,217.7 116.4,205.9 112.5,208  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.5,171.6l17.9,19.8c0,0,19.8-0.4,43.8,11.3c0,0,25.8-10.6,28.1-19.5c3.1-11.6-59.2-2.5-59.2-2.5L65.5,171.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M149.3,185.6v2.9c0,0.8-0.9,1.1-1.6,1.1H89c-0.8,0-1.7-0.3-1.7-1.1v-2.9H149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M149.3,185.6v2.9c0,0.8-0.9,1.1-1.6,1.1H89c-0.8,0-1.7-0.3-1.7-1.1v-2.9H149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.3,185.6v2.9c0,0.8-0.9,1.1-1.6,1.1H109c-0.8,0-1.6-0.3-1.6-1.1v-2.9H149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M159.1,155.1l-7,31.7c-0.3,1-1.2,1.8-2.3,1.8h-38.2c-0.8,0-1.5-0.7-1.5-1.6c0-0.2,0-0.3,0.1-0.4l7-31.5 c0.3-1,1.2-1.6,2.3-1.5h38.2C158.8,153.6,159.4,154,159.1,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M159.1,155.1l-7,31.7c-0.3,1-1.2,1.8-2.3,1.8H113c-0.9,0-1.5-0.7-1.5-1.6c0-0.1,0-0.3,0.1-0.4l7-31.5 c0.3-1,1.2-1.6,2.2-1.5h36.9C158.8,153.6,159.4,154,159.1,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.3,171.2L140.3,171.2c0,2.7-2.9,4.9-5,4.9s-3.4-2.2-2.8-4.9s2.7-4.8,4.8-4.9c-0.6,2.7,0.7,4.9,2.8,4.9 C140.2,171.2,140.3,171.2,140.3,171.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "132.1,218.6 144.6,220.6 150.6,221.6 152.3,215.4 146.9,213.8 133.6,209.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M151.1,214.4l-2.7,7c-0.2,0.4,0,0.8,0.4,1c0,0,0.1,0,0.1,0l3.5,1.2c0,0,4.6,2,6.1,1.4 c4.3-1.9,10.7-17.1,9.3-18.5c-0.5-0.5-1.6,0-2.2,0.4c-1.9,1.4-6.1,5.4-7.6,6.5c-1.9,1.3-4.7,0.9-5.9,0.6 C151.6,213.9,151.3,214.1,151.1,214.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "132.1,218.6 144.6,220.6 146.9,213.8 133.6,209.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.8,212.5c0,0-51-28.7-68.6-27.8s-20.1,16.3-12.9,26S84,222.7,84,222.7s-9.1-12.9-7.8-16.5s6.5,1.4,6.5,1.4 s32,10.3,60.1,12.8L144.8,212.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "145.6,211.7 142.7,209.7 139,221.1 143.4,221.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "145.6,211.7 142.7,209.7 139,221.1 143.4,221.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M56.1,165.9l32.5,3c0,0,5.1-10.5,9-14.6s7.4-25,7.4-25c-2.6-1.3-5.4-2.4-8.1-3.3c-8-2.7-16.4-4.1-24.8-4.2 h-0.1c-2.4,0-3.8,0.1-3.8,0.1c-1,0.7-1.8,1.6-2.3,2.6c-3.5,6-6.2,20-7.9,30C56.7,161,56.1,165.9,56.1,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.7,154.5c7.2-3.3,16.9-8.8,16.4-14.5c-0.6-6.2-5.6-12.4-8.5-15.6C62.1,130.5,59.4,144.5,57.7,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M73.5,121.7c0,0,3.7,12.2,13.8,13.5s11.8-8.5,11.8-8.5S86.1,119.6,73.5,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M73.5,121.7c0,0,3.7,12.2,13.8,13.5s11.8-8.5,11.8-8.5S86.1,119.6,73.5,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.6,122.1c0,0,4.8,11.3,13.4,11.3s8.9-6.3,8.9-6.3S89.3,121.4,75.6,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M75.6,122.1c0,0,4.8,11.3,13.4,11.3s8.9-6.3,8.9-6.3S89.3,121.4,75.6,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91.2,123.8c0.1,2,1.2,2.5,1.2,2.5c0.4,2.2-1.2,4.3-3.4,4.7c-0.3,0.1-0.7,0.1-1.1,0c-6.4-0.6-8.4-8.3-8.4-8.3 c4.6-1.8,5.7-7,5.9-10c0.1-0.8,0.1-1.6,0-2.4l8.7,5.5c-0.7,1.2-1.4,2.5-1.9,3.8C91.6,120.9,91.2,122.4,91.2,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.6,115.2c-0.6,1.3-1.1,2.6-1.5,4c-0.5,1.4-0.7,2.8-0.5,4.3c-4.9,0.4-6.8-10.4-6.8-10.4V113 c0-0.8-0.1-1.6-0.2-2.4L93.6,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M100.6,93.5c8.4,2.6,9.7,7.9,7.7,16.7c-2.5,11-7.2,18-17,12.5C78,115.2,86.7,89.3,100.6,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M103.1,108.1c0.3,1.5,0.7,2.9,1.4,4.2c-0.7,0.6-1.7,0.7-2.5,0.3L103.1,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M98.1,105.8c-0.2,0.7-0.7,1.1-1.2,1s-0.7-0.8-0.5-1.5s0.7-1.1,1.2-1S98.3,105.1,98.1,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M97.4,104.3l1.7-0.2C99.1,104.2,98,105.2,97.4,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M106.8,108.1c-0.2,0.7-0.7,1.1-1.2,1s-0.7-0.8-0.5-1.5s0.7-1.1,1.2-1S107,107.4,106.8,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M106.1,106.6l1.7-0.2C107.8,106.4,106.7,107.5,106.1,106.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M95.8,100.5c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0.1-0.2,0.2-0.3c1.3-0.8,3-0.8,4.4-0.2c0.2,0.1,0.3,0.3,0.2,0.5 c-0.1,0.2-0.3,0.3-0.5,0.2c0,0,0,0,0,0c-1.2-0.5-2.5-0.5-3.7,0.1C95.9,100.5,95.9,100.5,95.8,100.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M109.1,103.6c-0.1,0-0.2,0-0.3-0.1c-0.6-0.9-1.7-1.5-2.8-1.6c-0.2,0-0.4-0.1-0.4-0.3c0-0.2,0.1-0.4,0.3-0.4 c0,0,0,0,0,0c1.4,0,2.6,0.7,3.4,1.8c0.1,0.1,0.1,0.4,0,0.5C109.3,103.6,109.2,103.6,109.1,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M87.2,104.8c0,0,6-5.7,7-11.2c0,0,18.7-1.7,14.4,15.4c0,0,6.2-14.5-8.1-19.2s-20.6,16.4-15.1,24.9 C85.3,114.8,83.4,108.4,87.2,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M100,116.3L100,116.3c-2.3,0-4.3-1.7-4.6-3.9c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3 c0.3,1.9,2,3.4,3.9,3.3c0.2,0,0.4,0.2,0.4,0.4C100.4,116.2,100.2,116.3,100,116.3L100,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M85.7,103.2c0,0.1,0,0.2,0.1,0.3h0.1l8.5,2c-0.3,1.7,0.6,3.3,2.1,4c2,1,4.5,0.3,5.7-1.5 c0.1-0.2,0.2-0.4,0.3-0.6c0.3-0.3,0.7-0.4,1.1-0.3c0.2,0.1,0.4,0.3,0.4,0.5c-0.2,1.6,0.6,3.2,2.2,3.9c2,1,4.5,0.3,5.7-1.6 c1-1.7,0.4-4-1.3-5c-0.1-0.1-0.3-0.1-0.4-0.2c-2-1-4.5-0.3-5.7,1.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1-0.1-0.3-0.2-0.4-0.3 c-0.4-0.1-0.8-0.1-1.1,0.1c0.3-1.7-0.6-3.3-2.2-4c-2-1-4.5-0.3-5.7,1.5c-0.1,0.2-0.2,0.5-0.3,0.7l-8.5-2 C85.9,102.9,85.8,103,85.7,103.2z M105,106.5c1.1-1.7,3.2-2.2,5-1.4c1.6,0.7,2.4,2.6,1.7,4.2c-0.1,0.1-0.1,0.2-0.2,0.3 c-1.1,1.7-3.2,2.2-5,1.4c-1.6-0.7-2.4-2.5-1.7-4.2C104.9,106.7,105,106.6,105,106.5z M95.3,104.5c1.1-1.7,3.2-2.2,5-1.4 c1.6,0.7,2.4,2.6,1.7,4.2c-0.1,0.1-0.1,0.2-0.2,0.3c-1.1,1.7-3.2,2.2-5,1.4c-1.6-0.7-2.4-2.6-1.7-4.2 C95.2,104.7,95.3,104.6,95.3,104.5L95.3,104.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M85.7,103.2c0,0.1,0,0.2,0.1,0.3h0.1l8.5,2c-0.3,1.7,0.6,3.3,2.1,4c2,1,4.5,0.3,5.7-1.5 c0.1-0.2,0.2-0.4,0.3-0.6c0.3-0.3,0.7-0.4,1.1-0.3c0.2,0.1,0.4,0.3,0.4,0.5c-0.2,1.6,0.6,3.2,2.2,3.9c2,1,4.5,0.3,5.7-1.6 c1-1.7,0.4-4-1.3-5c-0.1-0.1-0.3-0.1-0.4-0.2c-2-1-4.5-0.3-5.7,1.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1-0.1-0.3-0.2-0.4-0.3 c-0.4-0.1-0.8-0.1-1.1,0.1c0.3-1.7-0.6-3.3-2.2-4c-2-1-4.5-0.3-5.7,1.5c-0.1,0.2-0.2,0.5-0.3,0.7l-8.5-2 C85.9,102.9,85.8,103,85.7,103.2z M105,106.5c1.1-1.7,3.2-2.2,5-1.4c1.6,0.7,2.4,2.6,1.7,4.2c-0.1,0.1-0.1,0.2-0.2,0.3 c-1.1,1.7-3.2,2.2-5,1.4c-1.6-0.7-2.4-2.5-1.7-4.2C104.9,106.7,105,106.6,105,106.5z M95.3,104.5c1.1-1.7,3.2-2.2,5-1.4 c1.6,0.7,2.4,2.6,1.7,4.2c-0.1,0.1-0.1,0.2-0.2,0.3c-1.1,1.7-3.2,2.2-5,1.4c-1.6-0.7-2.4-2.6-1.7-4.2 C95.2,104.7,95.3,104.6,95.3,104.5L95.3,104.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M88,107c0.4-2.1-0.9-4.1-2.9-4.6c-2.7-0.5-5.6,4.4,0.5,7.7C86.5,110.6,87.3,109.9,88,107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M71.8,132.8c0,0,1,21.4,2.8,26.2s20.7,22.5,20.7,22.5s5.3-1.2,6.1-0.8s5.9,5,5.9,5H92.8l-1.3-2.2 c0,0-19.5-14.5-21.7-17.9c-1.6-2.5-6.7-28.5-6.7-28.5L71.8,132.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.9,121.8c3.4-1.8,5,3.9,7.1,15.4c1.2,7.2,1.8,14.6,1.7,22l2.9,5.1l-7.3,6.7c-3.4-3.3-6.1-7.4-7.7-11.9 C62.3,152.3,56.1,128,67.9,121.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M67.9,121.8c3.4-1.8,5,3.9,7.1,15.4c1.2,7.2,1.8,14.6,1.7,22l2.9,5.1l-7.3,6.7c-3.4-3.3-6.1-7.4-7.7-11.9 C62.3,152.3,56.1,128,67.9,121.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "70.3,171.1 79.6,162.8 81.8,165.9 73.5,174  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "70.3,171.1 79.6,162.8 81.8,165.9 73.5,174  "
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.7,97.7c-4.6,5.9,4.8,12.6-4.6,12.3c-9.4-0.4-5.6-13.6,0-16.6S92.7,97.7,92.7,97.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.6,93.5c0,0-2.5,11.1-10.6,12.3c-8.1,1.2-6.2-10.8,4.6-15.2c10.9-4.4,19.7,4.4,20.2,6.7 c0.5,2.4-1.7,3.9-1.7,3.9S105.1,93.7,96.6,93.5z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M88.2,46.9c-0.3-1.6-1.1-3.2-2.4-4.3c-1.4-1.3-3.3-2-5.2-2c-1.5,0-2.9,0.4-4.2,1.2c-1,0.7-1.9,1.5-2.5,2.6 c-0.3,0-0.5-0.1-0.8-0.1c-2.3,0-4.2,1.8-4.2,4.1c0,0.3,0,0.6,0.1,0.9c-1.5,1.1-2.4,2.8-2.4,4.6c0,1.5,0.6,2.9,1.6,4.1 c1.1,1.2,2.4,1.9,3.9,1.9c0,0,0,0,0,0h4.7c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7h-4.7c-2.2-0.1-4.1-2.2-4.1-4.5 c0-1.5,0.8-2.9,2.2-3.7c0.3-0.2,0.4-0.5,0.3-0.9c-0.1-0.3-0.2-0.6-0.2-0.9c0-1.5,1.2-2.7,2.7-2.7c0.3,0,0.6,0.1,0.9,0.2 c0.4,0.1,0.8,0,0.9-0.4c1-2.1,3.2-3.5,5.6-3.5c3.2,0,5.9,2.4,6.2,5.5c0,0.3,0.3,0.6,0.6,0.6c2.4,0.4,4.3,2.6,4.3,5.1 c0,2.7-2.1,5-4.8,5.2h-4c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h4c0,0,0,0,0.1,0c1.7-0.1,3.2-0.9,4.4-2.1 c1.2-1.2,1.8-2.8,1.8-4.5C93.2,50.3,91.1,47.7,88.2,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M84.3,54.6c0.3-0.3,0.3-0.7,0-1l-3.9-3.8c-0.1-0.1-0.3-0.2-0.5-0.2s-0.4,0.1-0.5,0.2l-3.9,3.8 c-0.3,0.3-0.3,0.7,0,1c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2l2.6-2.6v11.9c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V52 l2.6,2.6C83.6,54.9,84,54.9,84.3,54.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07UploadAadhar);
export default __webpack_public_path__ + "static/media/07_Upload_aadhar.3c402b2399351b14619410f5cd99a0e4.svg";
export { ForwardRef as ReactComponent };